import { ITableSettings } from 'api/api';
import { localized } from 'state/i18n';
import { ColumnGeneric } from '../history-table-settings/types';
import { TableColumnWidthInfoGeneric } from '../table-settings/types';

export interface PredictionColumns {
	outerCollapsible: string;
	innerCollapsible: string;
	predictionDate: Date;
	predictedDaysUntilFull: number;
	predictedDate: Date;
	predictedFillLevel?: number;
	predictionError?: number;
	actualEmptiedDate: Date;
}

export type PredictionGroupingDtoKeys = keyof PredictionColumns;

export const allColumns: ColumnGeneric<PredictionGroupingDtoKeys>[] = [
	{ name: 'outerCollapsible', title: localized('DeviceGrouping') },
	{ name: 'innerCollapsible', title: localized('PredictionGrouping') },
	{ name: 'actualEmptiedDate', title: '' },
	{ name: 'predictionDate', title: localized('PredictionDate') },
	{ name: 'predictedDaysUntilFull', title: localized('PredictedDaysUntilFull') },
	{ name: 'predictedDate', title: localized('PredictedFullDate') },
	{ name: 'predictedFillLevel', title: localized('PredictedFillLevel') },
	{ name: 'predictionError', title: localized('ErrorInDays') },
];

export const predictionDateColumns: PredictionGroupingDtoKeys[] = [
	'predictedDate',
	'actualEmptiedDate',
	'predictionDate',
];

export const predictionAmountOfDaysColumns: PredictionGroupingDtoKeys[] = ['predictedDaysUntilFull', 'predictionError'];

export interface PredictionTableSettingsState {
	columnWidths: TableColumnWidthInfoGeneric<PredictionGroupingDtoKeys>[];
	columnOrder: PredictionGroupingDtoKeys[];
	columns: ColumnGeneric<PredictionGroupingDtoKeys>[];
	tableSettings: ITableSettings;
	loaded: boolean;
}
